import escapeHtml from "escape-html";
import { Text } from "slate";
import { jsx } from 'slate-hyperscript'


export const serialize = nodes => {
  return nodes.map(n => serializeNode(n)).join('')
}

const serializeNode = node => {

  const alignStatement = node.align ? ` align = "${node.align}"` : ``

  if (Text.isText(node)) {
    const styles = []

    let string = escapeHtml(node.text)
    if (node.bold) {
      string = `<strong>${string}</strong>`
    }
    if (node.italic) {
      string = `<em>${string}</em>`
    }
    if (node.underline) {
      string = `<u>${string}</u>`
    }
    if (node.color) {
      styles.push(`color: ${node.color}`)
    }
    if (node.backgroundColor) {
      styles.push(`background-color: ${node.backgroundColor}`)
    }
    if (node.fontSize) {
      styles.push(`font-size: ${node.fontSize}`)
    }
    if (styles.length > 0) {
      string = `<span style="${styles.join('; ')}">${string}</span>`
    }

    return string
  }

  const children = node.children.map(n => serializeNode(n)).join('')

  switch (node.type) {
    case 'block-quote':
      return `<blockquote><p${alignStatement}>${children}</p></blockquote>`
    case 'paragraph':
      return `<p${alignStatement}>${children}</p>`
    case 'heading-two':
      return `<h2${alignStatement}>${children}</h2>`
    case 'numbered-list':
      return `<ol>${children}</ol>`
    case 'bulleted-list':
      return `<ul>${children}</ul>`
    case 'list-item':
      return `<li>${children}</li>`
    default:
      return children
  }
}

const MENTION_REGEX = RegExp('(@mention{(.*?)})', 'gi');
export const deserialize = (el, markAttributes = {}) => {
  if (el.nodeType === Node.TEXT_NODE) {
    let deserialized = []
    let skip
    for(let text of el.textContent.split(MENTION_REGEX)) {
      if (skip) {skip = false; continue;}
      skip = false
      if(text.includes('@mention')){
        let mention = text.replace('@mention{', '').replace('}','')
        deserialized.push(jsx( 'element', {identifier:mention , type: 'mention'}, jsx('text', markAttributes, text)))
        skip = true
      } else {
        deserialized.push(jsx('text', markAttributes, text))
      }
    }
    return deserialized

  } else if (el.nodeType !== Node.ELEMENT_NODE) {
    return null
  }

  const nodeAttributes = { ...markAttributes }

  // define attributes for text nodes
  switch (el.nodeName) {
    case 'STRONG':
      nodeAttributes.bold = true
      break
    case 'EM':
      nodeAttributes.italic = true
      break
    case 'U':
      nodeAttributes.underline = true
      break
    case 'SPAN':
      const styleAttr = el.getAttribute('style') || ''

      styleAttr.split(';').forEach(rule => {
        const [property, value] = rule.split(':').map(s => s && s.trim())
        if (!property || !value) return

        if (property === 'color') {
          nodeAttributes.color = value
        }

        if (property === 'background-color') {
          nodeAttributes.backgroundColor = value
        }

        if (property === 'font-size') {
          nodeAttributes.fontSize = value
        }
      })
      break
  }

  const children = Array.from(el.childNodes)
                        .map(node => deserialize(node, nodeAttributes))
                        .flat()

  if (children.length === 0) {
    children.push(jsx('text', nodeAttributes, ''))
  }

  switch (el.nodeName) {
    case 'BODY':
      return jsx('fragment', {}, children)
    case 'BR':
      return '\n'
    case 'BLOCKQUOTE':
      return jsx('element', { type: 'block-quote', align: el.align }, children)
    case 'P':
      return jsx('element', { type: 'paragraph', align: el.align }, children)
    case 'H2':
      return jsx('element', { type: 'heading-two', align: el.align }, children)
    case 'OL':
      return jsx('element', { type: 'numbered-list' }, children)
    case 'UL':
      return jsx('element', { type: 'bulleted-list' }, children)
    case 'LI':
      return jsx('element', { type: 'list-item' }, children)
    default:
      return children
  }
}

